import { render, staticRenderFns } from "./FacebookMapping.vue?vue&type=template&id=5a90c5c8&scoped=true&"
import script from "./FacebookMapping.vue?vue&type=script&lang=ts&"
export * from "./FacebookMapping.vue?vue&type=script&lang=ts&"
import style0 from "./FacebookMapping.vue?vue&type=style&index=0&id=5a90c5c8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a90c5c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCardActions,VCardText,VCardTitle,VIcon,VSelect,VSpacer,VTextField,VTooltip})
